import { render, staticRenderFns } from "./MatMatriculaListByIdAlumno.vue?vue&type=template&id=7213e9ae&scoped=true&"
import script from "./MatMatriculaListByIdAlumno.vue?vue&type=script&lang=js&"
export * from "./MatMatriculaListByIdAlumno.vue?vue&type=script&lang=js&"
import style0 from "./MatMatriculaListByIdAlumno.vue?vue&type=style&index=0&id=7213e9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213e9ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCard,VDataTable,VIcon})
